import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, makeStyles, mergeClasses, Text } from '@fluentui/react-components';
import { DismissRegular } from '@fluentui/react-icons';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useCommonStyles } from '../../../common/hooks';
import { AI_SCRUB_OVERWRITE_WARNING } from '../../../common/scrubbing/ai-scrub-overwrite-warning';

const useStyles = makeStyles({
  modalSurface: {
    maxWidth: '416px',
    width: '100%',
  }
});

interface AiScrubOverwriteConfirmModalProps {
  onCancel(): void;
  onConfirm(): void;
}

const AiScrubOverwriteConfirmModalImpl: React.FC<AiScrubOverwriteConfirmModalProps> = (props) => {
  const {
    onCancel,
    onConfirm,
  } = props;

  const commonStyles = useCommonStyles();
  const styles = useStyles();

  return (
    <Dialog
      open
      onOpenChange={(_, data) => {
        if (!data.open) onCancel();
      }}
    >
      <DialogSurface
        className={mergeClasses(commonStyles.modalSurface, styles.modalSurface)}
      >
        <DialogBody className={commonStyles.modalBody}>
          <DialogTitle
            action={(
              <Button
                title='close'
                appearance='transparent'
                icon={<DismissRegular />}
                onClick={onCancel}
              />
            )}
          >
            Re-run AI review?
          </DialogTitle>
          <DialogContent>
            <Text as='p'>
              {AI_SCRUB_OVERWRITE_WARNING}
            </Text>
          </DialogContent>
          <DialogActions>
            <Button
              appearance='secondary'
              onClick={() => onCancel()}
            >
              Cancel
            </Button>
            <Button
              appearance='primary'
              onClick={() => onConfirm()}
            >
              Continue
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export const AiScrubOverwriteConfirmModal = observer(AiScrubOverwriteConfirmModalImpl);
